import { Suspense, useEffect } from "react";
// react router
import { Outlet } from "react-router";
// components
import SideDrawer from "../drawer/SideDrawer";
import ThreeDotsLoader from "../loader/ThreeDotsLoader";
// mui
import {
  Container,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  AppBar,
} from "@mui/material";
import { getMeta } from "../../redux/features/meta/metaSlice";
import { useDispatch } from "react-redux";
import { CgMenuRight } from "react-icons/cg";
const drawerWidth = 280;
const MainLayout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMeta() as any);
  }, [dispatch]);
  return (
    <Stack direction="row">
      <SideDrawer />
      <Stack
        sx={{
          flex: "1",
          maxHeigth: "100vh",
          height: "100vh",
          overflow: "auto",
          pt: 10,
          bgcolor: "background.subtle",
        }}
      >
        <Container>
          <Suspense fallback={<ThreeDotsLoader />}>
            <Outlet />
          </Suspense>
        </Container>
      </Stack>
    </Stack>
  );
};

export default MainLayout;
